import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import { DuplicateActionEnumModel } from "../../types/types";

interface DuplicateTransactionDialogProps {
  open: boolean;
  onClose: () => void;
  onViewDuplicate: () => void;
  onProceed: (action: DuplicateActionEnumModel) => void;
  duplicateId: number | null;
}

const DuplicateTransactionDialog: React.FC<DuplicateTransactionDialogProps> = ({
  open,
  onClose,
  onViewDuplicate,
  onProceed,
  duplicateId,
}) => {
  const [duplicateHandling, setDuplicateHandling] =
    useState<DuplicateActionEnumModel>(DuplicateActionEnumModel.Skip);

  const handleDuplicateHandlingChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDuplicateHandling(
      parseInt(event.target.value) as DuplicateActionEnumModel
    );
  };

  const handleProceed = () => {
    onProceed(duplicateHandling);
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmber color="warning" fontSize="large" />
          Duplicate Transaction Detected
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom color="text.primary">
          A similar transaction already exists in the system. This might be a
          duplicate entry.
        </Typography>

        <Box sx={{ mt: 3, mb: 3 }}>
          <Typography variant="subtitle2" gutterBottom>
            How should duplicate transactions be handled?
          </Typography>
          <RadioGroup
            value={duplicateHandling}
            onChange={handleDuplicateHandlingChange}
            aria-label="Duplicate handling options"
          >
            <FormControlLabel
              value={DuplicateActionEnumModel.Skip}
              control={<Radio size="small" />}
              label={
                <Typography variant="body2">
                  Ignore - Skip transactions that already exist
                </Typography>
              }
            />
            <FormControlLabel
              value={DuplicateActionEnumModel.Overwrite}
              control={<Radio size="small" />}
              label={
                <Typography variant="body2">
                  Replace - Delete duplicate transactions and replace them with
                  new uploads
                </Typography>
              }
            />
            <FormControlLabel
              value={DuplicateActionEnumModel.AddAsNew}
              control={<Radio size="small" />}
              label={
                <Typography variant="body2">
                  Duplicate - Add as new, potentially creating duplicate
                  transactions
                </Typography>
              }
            />
          </RadioGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={onClose} color="primary">
          Cancel
        </Button> */}
        <Button onClick={onViewDuplicate} color="primary" variant="outlined">
          View Existing Transaction
        </Button>
        <Button onClick={handleProceed} color="warning" variant="contained">
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateTransactionDialog;
